import { render, staticRenderFns } from "./ItemLauncherShops.vue?vue&type=template&id=23d15b60&scoped=true"
import script from "./ItemLauncherShops.vue?vue&type=script&lang=ts"
export * from "./ItemLauncherShops.vue?vue&type=script&lang=ts"
import style0 from "./ItemLauncherShops.vue?vue&type=style&index=0&id=23d15b60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d15b60",
  null
  
)

export default component.exports